<template>
  <PolkaCheckbox
    v-bind="$props"
    :disabled="disabled"
    class="flex flex-row"
    :class="[disabled ? 'opacity-50 cursor-default' : 'cursor-pointer']"
    @click-checkbox="clickCheckbox"
  >
    <template #icon="{ checkedModel }">
      <div
        :class="[checkedModel ? 'border-blue-500 bg-blue-500' : 'border-gray-400 bg-white']"
        class="inline-flex size-5 flex-none items-center justify-center rounded border"
      >
        <svg
          v-if="checkedModel"
          class="h-2.5 w-3.5 text-white"
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L5.70711 9.70711C5.31658 10.0976 4.68342 10.0976 4.29289 9.70711L0.292893 5.70711C-0.0976311 5.31658 -0.0976311 4.68342 0.292893 4.29289C0.683417 3.90237 1.31658 3.90237 1.70711 4.29289L5 7.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </template>
    <template #default="{ label: text }">
      <div class="text-gray-900 w-full flex justify-between">
        <div>
          <span class="font-semibold text-sm">
            {{ text }}
          </span>
          <span
            v-if="count"
            class="text-sm text-gray-600"
          >({{ count }})</span>
        </div>
        <div
          v-if="meta && meta.rating"
          class="flex items-center gap-1 text-sm font-semibold"
        >
          {{ meta.rating }}
          <svg
            width="12"
            height="12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.4.9a.6.6 0 0 1 1.2 0l1.1 3.3h3.5a.6.6 0 0 1 .4 1.2l-2.9 2 1.1 3.4a.6.6 0 0 1-1 .7L6 9.4l-2.8 2a.6.6 0 0 1-1-.6l1-3.4-2.8-2a.6.6 0 0 1 .4-1.2h3.5L5.4.9Z"
              fill="#FDBC15"
            />
          </svg>
        </div>
      </div>
    </template>
  </PolkaCheckbox>
</template>

<script setup>
import PolkaCheckbox from '~/components/shared/polka_checkbox.vue'

const props = defineProps({
  label: {
    type: [String, Number],
    default: null,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  id: {
    type: [String, Number],
    default: 1,
  },
  slug: {
    type: String,
    default: '',
  },
  meta: {
    type: Object,
    default: () => ({}),
  },
  count: {
    type: [String, Number],
    default: 0,
  },
  hasSelectedInGroup: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['clickCheckbox'])

const disabled = computed(() => {
  return !props.hasSelectedInGroup && props.count === 0
})

const clickCheckbox = (item) => {
  emit('clickCheckbox', item)
}
</script>
